module.exports = __webpack_public_path__ + "static/media/alicorn.7b69135d.svg";